
import { sha256 } from "js-sha256";
import { arrayBufferToBase64, base64ToArrayBuffer } from "./converters";
// import { decryptMessagePubKey, encryptMessagePubKey } from "./pubEncrypt";

// #region encrypt with FEK
export const encrypt = async (
    data: string,
    randomPassKey: string,
    feKey: CryptoKey
) => {
    const salt = crypto.getRandomValues(new Uint8Array(32));
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const encodedData = new TextEncoder().encode(data);
    const encodedPass = new TextEncoder().encode(sha256(randomPassKey))


    let encData = await crypto.subtle.encrypt(
        {
            name: "AES-GCM",
            iv,
        },
        feKey,
        encodedData
    );


    const encryptedDataInBytes = new Uint8Array(encData);


    // const encryptedDataInBytes = new Uint8Array(encData);

    const encryptedPackage = new Uint8Array(encodedPass.length + salt.length + iv.length + encryptedDataInBytes.length);
    let length = encodedPass.length;
    encryptedPackage.set(encodedPass);
    encryptedPackage.set(salt, length)
    length += salt.length;
    encryptedPackage.set(iv, length);
    length += iv.length;
    encryptedPackage.set(encryptedDataInBytes, length)

    return arrayBufferToBase64(encryptedPackage);
}
// #endregion encrypt with FEK

// #region decrypt with FEK
export const decrypt = async (
    encData: string,
    feKey: CryptoKey
) => {
    const convertedToArrayBuffer = base64ToArrayBuffer(encData);
    const encryptedData = new Uint8Array(convertedToArrayBuffer);

    // const passEnc = encryptedData.slice(0, 64);
    // let decSalt = encryptedData.slice(64, 96); //32
    let deciv = encryptedData.slice(96, 108); // 12
    const data = encryptedData.slice(108)

    let decrypt = await crypto.subtle.decrypt(
        {
            name: "AES-GCM",
            iv: deciv,
        },
        feKey,
        data
    );

    let originalData = new TextDecoder().decode(decrypt);

    return originalData;
}
// #endregion decrypt with FEK

